import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";

// Components
import CircularProgress from "components/master/CircularProgress";

// Scss
import "./ImpactsTracking.scss";

// Icons & Images
import ThumbsUp from "assets/icons/thumb-up.svg";
import ImpactSummary from "assets/icons/impact-summary.svg";
import BaselineIcon from "assets/icons/baseline-icon.svg";
import TargetValueIcon from "assets/icons/target-value-icon.svg";
import ActualValueIcon from "assets/icons/actual-value-icon.svg";
import MeasurementDatesIcon from "assets/icons/measurement-dates.svg";
import EmployeeRetention from "assets/icons/employee-retention.svg";
import PriorityIcon from "assets/icons/priority-icon.svg";
import Change from "assets/icons/change.svg";
import ChangeArrowGreen from "assets/icons/change-arrowgreen.svg";
import ChangeArrowAmber from "assets/icons/change-arrowamber.svg";
import ChangeArrowRed from "assets/icons/change-arrowred.svg";

import ActionsRequiredIcon from "assets/icons/actions-required.svg";
import Calenders from "assets/icons/calenders.svg";
import ProjectStatus from "assets/icons/project-status.svg";
import GreenBg from "assets/images/circular-green-bg.svg";
import BlueBg from "assets/images/circular-blue-bg.svg";
import YellowBg from "assets/images/circular-yellow-bg.svg";
import MODLoader from "assets/images/mod-loader.gif";

// Variables & Constants
const apiUri = "https://arrowmod.dig-x.co.in";

function ImpactsTrackingDash() {
  const { state } = useLocation();
  let [isLoader, setIsLoader] = useState(false);


  let [impactsTrackingData, setImpactsTrackingData] = useState([]);
  let [projectsStrategicObjectives, setProjectsStrategicObjectives] = useState(
    []
  );

  useEffect(() => {
    async function fetchData() {
      setIsLoader(true);
      const response = await axios.get(
        `${apiUri}/api/Impacts?StrObjective=${state.selected}`
      );
      setImpactsTrackingData(response.data);
      setIsLoader(false);
    }
    fetchData();
  }, [state]);

  useEffect(() => {
    async function fetchData() {
      setIsLoader(true);
      const response = await axios.get(
        `${apiUri}/api/Projects?StrObjective=${state.selected}`
      );
      setProjectsStrategicObjectives(response.data);
      setIsLoader(false);
    }
    fetchData();
  }, [state]);

  return (
    <>
      {isLoader && (
        <div className="loader-container">
          <img src={MODLoader} alt="#" />
        </div>
      )}
      <section className="ref-benefit">
        <div className="tile benefit">
          <div className="ref-mark">
            <div className="circular-icon-container">
              <img src={ThumbsUp} alt="#" />
            </div>
            <div className="title">Strategic Objective</div>
          </div>
          <div className="ref-alpha so">
            <div className="value">
              <p>{state.selected}</p>
            </div>
          </div>
        </div>
      </section>

      {impactsTrackingData.length > 0  ? (
        ImpactSection(impactsTrackingData)
      ) : (
        <div>No Measurements Found</div>
      )}
      {/* <section className="impact-summary">
        <div className="tile">
          <div className="impact-summary-head">
            <div className="lines gap-right">
              <hr/>
            </div>
              <span>
                <img src={ImpactSummary} alt="#" />
                Project Summary
              </span>
            <div className="lines gap-left">
              <hr/>
            </div>
          </div>
          <div className="summary-detail">
            <div className="detail-container">
              <div className="icon-value">
                <span>
                  <img src={Rag} alt="#" />
                  Current RAG Status
                </span>
              </div>
              <div className="stick-end">
                <span className="tag"></span>
              </div>
            </div>
            <div className="detail-container">
              <div className="icon-value">
                <span>
                  <img src={UserIcon} alt="#" />
                  Director Owner
                </span>
              </div>
              <div className="stick-end">
                <span>An Other</span>
              </div>
            </div>
            <div className="detail-container">
              <div className="icon-value">
                <span>
                  <img src={CalendarIcon} alt="#" />
                  End date to be realized
                </span>
              </div>
              <div className="stick-end">
                <span>23-03-2022</span>
              </div>
            </div>
            <div className="detail-container">
              <div className="icon-value">
                <span>
                  <img src={UserIcon} alt="#" />
                   Operational Owner
                </span>
              </div>
              <div className="stick-end">
                <span>An Other</span>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {projectsStrategicObjectives.length > 0 ? (
        ProjectSection(projectsStrategicObjectives)
      ) : (
        <div>No Projects Found</div>
      )}
    </>
  );
}

function ImpactSection(impactsTrackingData) {
  function generateUUID() {
    return uuidv4(); // ⇨ '9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d'
  }
  function getOnlyDate(dateTime) {
    let date = new Date(dateTime);
    let year = date.getFullYear();
    let month =
      date.getMonth().toString().length > 1
        ? date.getMonth()
        : "0" + date.getMonth();

    let day =
      date.getDate().toString().length > 1
        ? date.getDate()
        : "0" + date.getDate();

    month = parseInt(month) + 1;
    let dateWithoutTime = day + "-" + month + "-" + year;
    return dateWithoutTime;
  }

  const impactSections = impactsTrackingData.map((item, index) => {
    return (
      <div key={index}>
        <section>
          <div className="section-header">
            <div className="lines gap-right">
              <hr />
            </div>
            <div className="header-info">
              <div className="icon-container">
                <img src={ImpactSummary} alt="#" />
              </div>
              <div className="info-container">
                <span>MEASUREMENT OF IMPACT</span>
                <span>{item.IMPACTNAME}</span>
              </div>
            </div>
            <div className="lines gap-left">
              <hr />
            </div>
          </div>
        </section>
        <section className="charts-and-data">
          <div className="employee-status mr">
            <div
              className={`
              icon-holder 
              ${
                  item.CHANGE >= -5
                  ? "green"
                  : item.CHANGE < -5 && item.CHANGE >= -10
                  ? "amber"
                  : "red"
              }
            `}
            >
              <img src={EmployeeRetention} alt="#" />
            </div>

            <span>{item.IMPACTNAME}</span>

            <div className="status-holder">
              <span className="status-label">Status</span>
              <div
                className={`
                status
                ${
                  item.CHANGE >= -5
                  ? "green"
                  : item.CHANGE < -5 && item.CHANGE >= -10
                  ? "amber"
                  : "red"
                }
              `}
              ></div>
            </div>
          </div>
          <div className="chart-container mr baseline-value">
            <img src={BaselineIcon} alt="#" />
            <CircularProgress
              data={{
                pbId: `pb-${generateUUID()}`,
                vcId: `vc-${generateUUID()}`,
                img: GreenBg,
                value: `${item.TARGETVALUE}`,
              }}
            />
            <span>Baseline Value</span>
          </div>
          <div className="chart-container mr target-value">
            <img src={TargetValueIcon} alt="#" />
            <CircularProgress
              data={{
                pbId: `pb-${generateUUID()}`,
                vcId: `vc-${generateUUID()}`,
                img: BlueBg,
                value: `${item.TARGETVALUE}`,
              }}
            />
            <span>Target Value</span>
          </div>
          <div className="chart-container mr actual-value">
            <img src={ActualValueIcon} alt="#" />
            <CircularProgress
              data={{
                pbId: `pb-${generateUUID()}`,
                vcId: `vc-${generateUUID()}`,
                img: YellowBg,
                value: `${item.ACHIEVED}`,
              }}
            />
            <span>Actual Value</span>
          </div>
          <div className="data-container mr">
            <div className="top-float">
              <span>
                <img src={MeasurementDatesIcon} alt="#" />
                Measurement Dates
              </span>
              <div className="dates">
                <span>Baseline</span>
                <div className="seperator">
                  <hr />
                </div>
                <span>{getOnlyDate(item.BASELINEDATE)}</span>
              </div>
              <div className="dates">
                <span>Previous</span>
                <div className="seperator">
                  <hr />
                </div>
                <span>{getOnlyDate(item.PREVIOUSDATE)}</span>
              </div>
              <div className="dates">
                <span>Current</span>
                <div className="seperator">
                  <hr />
                </div>
                <span>{getOnlyDate(item.CURRENTDATE)}</span>
              </div>
            </div>
            <div className="done-by">
              <span>Measurement To Be Done By</span>
              <span>{item.MEASUREMENTTO}</span>
            </div>
          </div>
        </section>
        <section className="meta-data">
          <div className="date-container">
            <div className="top-float sep">
              <span>
                <img src={Calenders} alt="#" />
                <div>
                  <span>START DATE</span>
                  <span className="date">{getOnlyDate(item.STARTDATE)}</span>
                </div>
              </span>
            </div>
            <div className="bottom-float sh-none">
              <span>
                <img src={Calenders} alt="#" />
                <div>
                  <span>END DATE</span>
                  <span className="date">{getOnlyDate(item.ENDDATE)}</span>
                </div>
              </span>
            </div>
          </div>
          <div className="basic-tile mr">
            <img src={PriorityIcon} alt="#" />
            <span>Priority</span>
            <span
              className={`
              pnumber
              ${
                item.PRIORTY === 0 || item.PRIORTY === 1
                  ? "verylow"
                  : item.PRIORTY === 2
                  ? "low"
                  : item.PRIORTY === 3
                  ? "medium"
                  : item.PRIORTY === 4
                  ? "high"
                  : item.PRIORTY === 5
                  ? "veryhigh"
                  : ""
              }
            `}
            >
              {item.PRIORTY}
              <span className="outof">/ 5</span>
            </span>
            <div className="color-meanings">
              <div className="color-codes">
                <div className="circle verylow"></div>
                <span className="verylow">VERY LOW</span>
              </div>
              <div className="color-codes">
                <div className="circle low"></div>
                <span className="low">LOW</span>
              </div>
              <div className="color-codes">
                <div className="circle medium"></div>
                <span className="medium">MEDIUM</span>
              </div>
              <div className="color-codes">
                <div className="circle high"></div>
                <span className="high">HIGH</span>
              </div>
              <div className="color-codes">
                <div className="circle veryhigh"></div>
                <span className="veryhigh">VERY HIGH</span>
              </div>
            </div>
          </div>
          <div className="basic-tile mr">
            <div
              className={`
              icon-holder 
              ${
                item.CHANGE >= -5
                ? "green"
                : item.CHANGE < -5 && item.CHANGE >= -10
                ? "amber"
                : "red"
              }
            `}
            >
              <img src={Change} alt="#" />
            </div>
            <span>Change</span>
            <div className="change-percentage">
              <img
                src={`
                  ${
                    item.CHANGE >= -5 ? ChangeArrowGreen : 
                    item.CHANGE < -5 && item.CHANGE >= -10 ? ChangeArrowAmber : ChangeArrowRed
                  }
                `}
                alt="#"
                className={`
              ${
                item.CHANGE === 0 ? '' : 
                item.CHANGE > 0 ? 'rotate-up' : 'rotate-down' 
              }
            `}
              />
              <span
                className={`
                ${
                  item.CHANGE >= -5 ? 'green-text' : 
                  item.CHANGE < -5 && item.CHANGE >= -10 ? 'amber-text' : 'red-text'
                }
            `}
              >
                {item.CHANGE}
              </span>
            </div>
            <div
              className={`
              p-bar
              ${
                item.CHANGE >= -5 ? 'green-blur' : 
                item.CHANGE < -5 && item.CHANGE >= -10 ? 'amber-blur' : 'red-blur'
              }
            `}
            >
              <div
                className={`
                  p-bar-percentage
                  ${
                    item.CHANGE >= -5 ? 'green' : 
                    item.CHANGE < -5 && item.CHANGE >= -10 ? 'amber' : 'red'
                  }
                `}
                style={{ width: item.CHANGE }}
              ></div>
            </div>
          </div>
          <div className="stretch-tile mr">
            <img src={ActionsRequiredIcon} alt="#" />
            <span>REASON FOR CHANGE</span>
            <div className="typography">
              <p>
                {item.REASONFORCHANGE == null
                  ? "Not Applicable"
                  : item.REASONFORCHANGE}
              </p>
            </div>
          </div>
          <div className="stretch-tile mr">
            <img src={ActionsRequiredIcon} alt="#" />
            <span>ACTIONS REQUIRED TO REALISE THE BENEFIT</span>
            <div className="typography">
              <p>
                {item.ACTIONREQUIRED == null
                  ? "Not Applicable"
                  : item.ACTIONREQUIRED}
              </p>
            </div>
          </div>
        </section>
      </div>
    );
  });
  return impactSections;
}

function ProjectSection(projectsStrategicObjectives) {
  function getOnlyDate(dateTime) {
    let date = new Date(dateTime);
    let year = date.getFullYear();
    let month =
      date.getMonth().toString().length > 1
        ? date.getMonth()
        : "0" + date.getMonth();

    let day =
      date.getDate().toString().length > 1
        ? date.getDate()
        : "0" + date.getDate();

    month = parseInt(month) + 1;
    let dateWithoutTime = day + "-" + month + "-" + year;
    return dateWithoutTime;
  }
  return (
    <section className="project-status">
      <div className="section-inner-header">
        <img src={ProjectStatus} alt="#" />
        <span className="head-title">PROJECT STATUS</span>
      </div>
      <table>
        <thead>
          <tr>
            <th>Project ID</th>
            <th>Project Name</th>
            <th>Implementing Agent</th>
            <th>Duration</th>
            <th>Start Date</th>
            <th>Finish Date</th>
            <th>CPI</th>
            <th>SPI</th>
            <th>% Completed</th>
            <th>Overall Status</th>
            <th>Remarks</th>
          </tr>
        </thead>
        <tbody>
          {projectsStrategicObjectives.map((item) => {
            return (
              <tr>
                <td>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="http://kpmg.dig-x.co.in/#/project-ar?id=f3983d67-6574-eb11-8af0-005056921d78"
                  >
                    {item.PROJECTID}
                  </a>
                </td>
                <td>{item.PROJECTNAME}</td>
                <td>{item.IMPLEMENTINGAGENT != null ? item.IMPLEMENTINGAGENT : 'NA'}</td>
                <td>{item.DURATION}</td>
                <td>{getOnlyDate(item.STARTDATE)}</td>
                <td>{getOnlyDate(item.ENDDATE)}</td>
                <td>{item.CPI}</td>
                <td>{item.SPI}</td>
                <td>{item.COMPLETED}%</td>
                <td className={`
                  ${
                    item.OVERALLSTATUS === 'On Track' ? 'on-track' :
                    item.OVERALLSTATUS === 'Moderate Delay' ? 'moderate-delay': 
                    item.OVERALLSTATUS === 'Significant Delay' ? 'significant-delay':  'not-started'
                  }
                
                `}>{item.OVERALLSTATUS}</td>
                <td>{item.REMARKS != null ? item.REMARKS : 'NA'}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </section>
  );
}

export default ImpactsTrackingDash;
